export const ORGANIZATION_STATUS = {
  ACTIVE: 'ACTIVE',
  SUSPENDED: 'SUSPENDED',
} as const;
export type OrganizationStatus = (typeof ORGANIZATION_STATUS)[keyof typeof ORGANIZATION_STATUS];

export const MEMBERSHIP_STATUS = {
  ACTIVE: 'ACTIVE',
  SUSPENDED: 'SUSPENDED',
} as const;
export type MembershipStatus = (typeof MEMBERSHIP_STATUS)[keyof typeof MEMBERSHIP_STATUS];

export const INVITATION_STATUS = {
  PENDING: 'PENDING',
  ACCEPTED: 'ACCEPTED',
  EXPIRED: 'EXPIRED',
  REVOKED: 'REVOKED',
} as const;
export type InvitationStatus = (typeof INVITATION_STATUS)[keyof typeof INVITATION_STATUS];

export const ISSUE_TYPE = {
  STORY: 'STORY',
  TASK: 'TASK',
  BUG: 'BUG',
  SUBTASK: 'SUBTASK',
} as const;
export type IssueType = (typeof ISSUE_TYPE)[keyof typeof ISSUE_TYPE];

export const ISSUE_PRIORITY = {
  LOWEST: 'LOWEST',
  LOW: 'LOW',
  MEDIUM: 'MEDIUM',
  HIGH: 'HIGH',
  HIGHEST: 'HIGHEST',
} as const;
export type IssuePriority = (typeof ISSUE_PRIORITY)[keyof typeof ISSUE_PRIORITY];

export const STATUS_CATEGORY = {
  TODO: 'TODO',
  IN_PROGRESS: 'IN_PROGRESS',
  DONE: 'DONE',
} as const;
export type StatusCategory = (typeof STATUS_CATEGORY)[keyof typeof STATUS_CATEGORY];

export const SPRINT_STATE = {
  PLANNED: 'PLANNED',
  ACTIVE: 'ACTIVE',
  COMPLETED: 'COMPLETED',
} as const;
export type SprintState = (typeof SPRINT_STATE)[keyof typeof SPRINT_STATE];

export const ISSUE_LINK_TYPE = {
  BLOCKS: 'BLOCKS',
  IS_BLOCKED_BY: 'IS_BLOCKED_BY',
  RELATES_TO: 'RELATES_TO',
  DUPLICATES: 'DUPLICATES',
  DUPLICATED_BY: 'DUPLICATED_BY',
} as const;
export type IssueLinkType = (typeof ISSUE_LINK_TYPE)[keyof typeof ISSUE_LINK_TYPE];

export const PROJECT_ROLE = {
  LEAD: 'LEAD',
  MEMBER: 'MEMBER',
  VIEWER: 'VIEWER',
} as const;
export type ProjectRole = (typeof PROJECT_ROLE)[keyof typeof PROJECT_ROLE];

export const ACTIVITY_ACTION = {
  CREATED: 'CREATED',
  UPDATED: 'UPDATED',
  COMMENTED: 'COMMENTED',
  STATUS_CHANGED: 'STATUS_CHANGED',
  ASSIGNED: 'ASSIGNED',
  LINKED: 'LINKED',
  UNLINKED: 'UNLINKED',
  DELETED: 'DELETED',
  REASSIGNED_ISSUES: 'REASSIGNED_ISSUES',
  INVITATION_SENT: 'INVITATION_SENT',
  INVITATION_REVOKED: 'INVITATION_REVOKED',
  MEMBER_ADDED: 'MEMBER_ADDED',
  MEMBER_REMOVED: 'MEMBER_REMOVED',
  ORG_CREATED: 'ORG_CREATED',
  ORG_SUSPENDED: 'ORG_SUSPENDED',
  ORG_REACTIVATED: 'ORG_REACTIVATED',
} as const;
export type ActivityAction = (typeof ACTIVITY_ACTION)[keyof typeof ACTIVITY_ACTION];
